"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = createLogger;
function createLogger(isEnabled) {
    return {
        info: isEnabled ? console.info.bind(console) : () => { },
        debug: isEnabled ? console.debug.bind(console) : () => { },
        error: isEnabled ? console.error.bind(console) : () => { },
    };
}
//# sourceMappingURL=log.js.map